import { Fragment } from 'react';

import classNames from 'classnames';
import FormErrorMessage from 'components/FormErrorMessage';
import { FormInput } from 'components/FormInput/FormInput';
import get from 'lodash/get';

const NumberField = ({
  addon,
  autoFocus,
  block,
  disabled = false,
  input,
  label,
  id,
  msg,
  min,
  max,
  step,
  meta: { touched, error },
  className,
  spaceTop,
  style,
  wrapStyle,
  errorMessageStyle,
  wrapperClassName = '',
}) => {
  const onBlur = (e) => {
    if (typeof input.value === 'number') {
      input.onBlur(Number(e.target.value));
    } else {
      input.onChange(e.target.value);
    }
  };

  const onChange = (e) => {
    if (typeof input.value === 'number' && e.target.value !== '') {
      input.onChange(Number(e.target.value));
    } else {
      input.onChange(e.target.value);
    }
  };

  return (
    <Fragment>
      <div
        style={wrapStyle}
        className={classNames(
          wrapperClassName,
          block ? 'block' : 'table',
          'align-middle',
          'mb-0',
        )}
      >
        <FormInput
          {...input}
          autoFocus={autoFocus}
          id={id}
          className={className}
          disabled={disabled}
          hasError={touched && error}
          placeholder={label}
          spaceTop={spaceTop}
          min={min}
          max={max}
          step={step}
          style={style}
          onBlur={onBlur}
          onChange={onChange}
          type='number'
        />
        {addon && <div className='input-group-addon mr-3'>{addon}</div>}
      </div>
      {touched && error && (
        <FormErrorMessage style={errorMessageStyle}>
          {get(msg, ['validation', error], 'Error')}
        </FormErrorMessage>
      )}
    </Fragment>
  );
};

export default NumberField;
